import './App.css';
import { useEffect, useState } from 'react';
import backLogo from './back.png';
import resetLogo from './reset.png';
import infoLogo from './info.png';
import { isDesktop } from 'react-device-detect';

function App() {
  const [banReason, setBanReason] = useState('');

  const [words, setWords] = useState({
    N1: {M: [], D: [], H: [], B: [], G: [], K: [], Re: []},
    N2: {M: [], D: [], H: [], B: [], G: [], K: [], Re: []},
    N3: {M: [], D: [], H: [], B: [], G: [], K: [], Re: []},
    N4: {M: [], D: [], H: [], B: [], G: [], K: [], Re: []},
    N5: {M: [], D: [], H: [], B: [], G: [], K: [], Re: []},
    Kana: {Hi: [], Ga: [], Re: []}
  });
  const [wordsInfo, setWordsInfo] = useState({
    N1: [],
    N2: [],
    N3: [],
    N4: [],
    N5: [],
    Kana: []
  });

  const [level, setLevel] = useState('');
  const [part, setPart] = useState('');
  const [_, setGlobalState] = useState();

  useEffect(() => {
    if(isDesktop) setBanReason('모바일 접속만 가능합니다.');
    else if(window.innerWidth > window.innerHeight) setBanReason('가로모드는 지원하지 않습니다.');

    window.addEventListener('resize', () => {
      if(window.innerWidth > window.innerHeight) setBanReason('가로모드는 지원하지 않습니다.');
      else setBanReason('');
    });
  }, []);

  useEffect(() => {
    if(level && part === 'Re' && JSON.stringify(words[level]['Re']) !== localStorage.getItem(level + '_restudy')){
      const word_arr = JSON.parse(localStorage.getItem(level + '_restudy'));
      setWords({
        ...words,
        [level]: {
          ...words[level],
          ['Re']: word_arr
        }
      });
    }
    else if(level && part && !words[level][part].length){
      fetch(`/${level}/${part}.json`)
      .then(res => res.json())
      .then(word_arr => {
        setWords({
          ...words,
          [level]: {
            ...words[level],
            [part]: word_arr
          }
        });
      })
      .catch (() => {
        window.location.reload();
      });
    }
  }, [level, part, words, _]);

  useEffect(() => {
    if(level && level !== 'Kana' && !wordsInfo[level].length){
      fetch(`/${level}/moreInfo.txt`)
      .then(res => res.text())
      .then(text => {
        const wi_arr = text.replaceAll('\r', '').split('\n');
        setWordsInfo({
          ...wordsInfo,
          [level]: wi_arr.map(d => d.split('|')),
        })
      });
    }
  }, [level, wordsInfo])

  const pageChanger = () => {
    if(banReason) return <div className='connection_fail'>{banReason}</div>
    if(level === '') return <Select_Level setLevel={setLevel}/>;
    if(part === '') return <Select_Part setLevel={setLevel} setPart={setPart} level={level}/>;
    return <Study setPart={setPart} level={level} part={part} words={words[level][part]} wordsInfo={wordsInfo[level]}
    setGlobalState={setGlobalState}/>;
  }

  return (
    <div className="App">
      {pageChanger()}
    </div>
  );
}

function Select_Level(props) {
  return (
    <div className='select_level'>
      <button onClick={() => props.setLevel('Kana')}>히라가나 & 가타카나</button>
      <button onClick={() => props.setLevel('N5')}>N5 어휘</button>
      <button onClick={() => props.setLevel('N4')}>N4 어휘</button>
      <button onClick={() => props.setLevel('N3')}>N3 어휘</button>
      <button onClick={() => props.setLevel('N2')}>N2 어휘</button>
      <button onClick={() => props.setLevel('N1')}>N1 어휘</button>
    </div>
  );
}

function Select_Part(props) {
  const [restudy_target, setRestudyTarget] = useState();
  const [body, setBody] = useState();

  useState(() => {
    if(props.level === 'Kana') {
      setRestudyTarget('가나');
      setBody(
      <div className='body'>
        <button onClick={() => props.setPart('Hi')}>히라가나</button>
        <button onClick={() => props.setPart('Ga')}>가타카나</button>
      </div>);
    }
    else {
      setRestudyTarget('단어');
      setBody(
      <div className='body'>
        <button onClick={() => props.setPart('M')}>명사</button>
        <button onClick={() => props.setPart('D')}>동사</button>
        <button onClick={() => props.setPart('H')}>형용사</button>
        <button onClick={() => props.setPart('B')}>부사</button>
        <button onClick={() => props.setPart('G')}>기타</button>
      </div>);
    }
  }, []);

  return (
    <div className='select_part'>
      <div className='header'>
        <img src={backLogo} onClick={() => {props.setLevel('')}}/>
        <div className='level'>{props.level}</div>
        <div className='restudy' onClick={() => {
          if(localStorage.getItem(props.level + '_restudy')) props.setPart('Re');
          else window.alert(`복습할 ${restudy_target}가 없습니다`);
        }}>복습</div>
      </div>
      {body}
    </div>
  );
}

function Select_Section (props){
  const [sections, setSections] = useState({});
  
}

function Study(props) {
  const [index, setIndex] = useState(0);
  const [open, setOpen] = useState(false);
  const [seq, setSeq] = useState([]);
  const [wordInfo, setWordInfo] = useState('');
  const [_, setState] = useState();

  const partHanguel = (part) => {
    if(part === 'M') return '명사';
    if(part === 'D') return '동사';
    if(part === 'H') return '형용사';
    if(part === 'B') return '부사';
    if(part === 'G') return '기타';
    if(part === 'Re') return '복습';
    if(part === 'Hi') return '히라가나';
    if(part === 'Ga') return '가타카나';
  }

  const getWordInfoTag = (word) => {
    const wordData = props.wordsInfo.find(d => d[0] === word?.[1]);
    if(open && wordData){
      const info = wordData[1];
      return <div className='info' onClick={() => {setWordInfo(info)}}><img src={infoLogo}></img>추가 정보 보기</div>
    }
    else {
      return <div className='info'></div>
    }
  }
  const WordAlreaySaved = (level, word) => {
    const savedWord = JSON.parse(localStorage.getItem(level + '_restudy'));
    if(!savedWord) return false;
    return savedWord.find(w => JSON.stringify(w) === JSON.stringify(word)) !== undefined;
  }
  const getButtonText = () => {
    if(open){
      if(props.part === 'Re') return '복습 완료';
      else if(WordAlreaySaved(props.level, props.words[seq[index]])) return <b style={{color: 'rgb(128, 128, 256)'}}>복습 추가됨</b>;
      else return '복습 추가';
    }
    else if(props.level === 'Kana'){
      return '발음 확인';
    }
    else {
      return '뜻 확인';
    }
  }

  useEffect( () => {
    const savedIndex = localStorage.getItem(props.level + props.part + '_index');
    if(!savedIndex) setIndex(0);
    else setIndex(Number(savedIndex));
  }, []);

  useEffect( () => {
    if (props.part !== 'Re') {
      const savedSequence = localStorage.getItem(props.level + props.part + '_seq');
      if(props.words.length && !savedSequence) {
        const num_arr = Array.from({ length: props.words.length }, (_, i) => i);
        num_arr.sort(() => Math.random() - 0.5);
        localStorage.setItem(props.level + props.part + '_seq', JSON.stringify(num_arr));
        setSeq(num_arr);
      }
      else if(props.words.length && savedSequence && !seq.length) {
        setSeq(JSON.parse(savedSequence));
      }
    }
  }, [props.words, seq]);

  return (
    <div className='study'>
      <div className='header'>
        <img className='back' src={backLogo} onClick={() => {props.setPart('');}}/>
        <div className='title'>{props.level !== 'Kana' ? props.level : (props.part === 'Re' ? '가나' : '')} {partHanguel(props.part)}</div>
        <img className='reset' src={resetLogo} onClick={() => {
          if(window.confirm(`진행과정을 초기화 하시겠습니까?\n(${props.level === 'Kana' ? '가나' : '단어'} 순서도 변경됩니다.)`)){
            localStorage.removeItem(props.level + props.part + '_seq');
            localStorage.removeItem(props.level + props.part + '_index');
            setIndex(0);
            setSeq([]);
            setOpen(false);
          }
        }}/>
      </div>
      <div className='body'>
        {getWordInfoTag(props.part === 'Re' ? props.words[index] : props.words[seq[index]])}
        <div className='word'>
          <div className='yomikata' style={open ? {} : {display: 'none'}}>
            {seq.length ? props.words[seq[index]]?.yomikata : props.words[index]?.yomikata}
          </div>
          <div className='kanji'>
            {seq.length ? props.words[seq[index]]?.tango : props.words[index]?.tango}
          </div>
          <div className='imi' style={open ? {} : {display: 'none'}}>
            {seq.length ? props.words[seq[index]]?.imi : props.words[index]?.imi}
          </div>
        </div>
        <button onClick={() => {
          if(!open) setOpen(true); 
          else {
            const savedWord = JSON.parse(localStorage.getItem(props.level + '_restudy'));
            if (props.part !== 'Re') {
              const newWord = props.words[seq[index]];
              if(WordAlreaySaved(props.level, newWord)) {
                window.alert('이미 복습 목록에 있습니다.');
                return;
              }

              if(savedWord) {
                savedWord.push(newWord);
                localStorage.setItem(props.level + '_restudy', JSON.stringify(savedWord));
              }
              else{
                localStorage.setItem(props.level + '_restudy', JSON.stringify([newWord]));
              } 
              alert('복습 목록에 추가되었습니다.');
              setState({}); // 리렌더리용
            }
            else {
              const nowWordStr = JSON.stringify(props.words[index]);
              const updatedSavedWord = savedWord.filter(word => JSON.stringify(word) !== nowWordStr);
              localStorage.setItem(props.level + '_restudy', JSON.stringify(updatedSavedWord));
              setOpen(false);
              if(savedWord.length === 1){
                localStorage.removeItem(props.level + '_restudy');
                localStorage.removeItem(props.level + 'Re_index');
                window.alert('복습을 모두 끝냈습니다.');
                props.setPart('');
              }
              else if(index === savedWord.length - 1) {
                localStorage.setItem(props.level + 'Re_index', index - 1);
                setIndex(index - 1);
              }
              window.alert('복습 목록에서 삭제되었습니다.');
              props.setGlobalState({});
            }
          }
        }}>{getButtonText()}</button>
      </div>
      <div className='footer'>
        <button onClick={() => {
          if(index > 0) {
            setIndex(index - 1); 
            setOpen(false); 
            localStorage.setItem(props.level + props.part + '_index', index - 1);
          }
        }}>◀</button>
        <div>{index + 1} / {props.words.length}</div>
        <button onClick={() => {
          if(index < props.words.length - 1) {
            setIndex(index + 1); 
            setOpen(false);
            localStorage.setItem(props.level + props.part + '_index', index + 1);
          }
        }}>▶</button>
      </div>
      {wordInfo === '' ? <></> : 
        <div className='wordInfo'>
          <div className='word'>{props.part !== 'Re' ? props.words[seq[index]].tango : props.words[index].tango}</div>
          <div className='info'>{wordInfo}</div>
          <button onClick={() => {setWordInfo('')}}>확인</button>
        </div>
      }
    </div>
  );
}


export default App;
